const InputType = {
	CSV: "CSV",
	GEOJSON: "GeoJSON"
};
export default InputType;
